module.exports = __webpack_public_path__ + "static/img/20017 (8).93ba586.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20017 (8).webp
// module id = SV+X
// module chunks = 14